import { OnInit, NgZone, ElementRef, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { debounceTime, takeWhile } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import * as fromStore from '@ibe/store/index';
var BackToTopComponent = /** @class */ (function () {
    function BackToTopComponent(zone, store) {
        var _this = this;
        this.zone = zone;
        this.store = store;
        this.milesBarHeight$ = this.store.select(fromStore.getMilesBarHeight);
        this.isScrolled = false;
        this.didScrollUp = false;
        this.showAtPossition = 80;
        this.lastScrollTop = 0;
        this.isScrolling = false;
        this.brighter = false;
        this.isAlive = true;
        this.scrollSubject = new Subject();
        this.milesBarHeight$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (milesBarHeight) { return _this.milesBarHeight = milesBarHeight; });
    }
    Object.defineProperty(BackToTopComponent.prototype, "bottomGapValue", {
        get: function () {
            return {
                'transform': 'translateY(-' + this.milesBarHeight + 'px)'
            };
        },
        enumerable: true,
        configurable: true
    });
    BackToTopComponent.prototype.ngOnInit = function () {
        var _this = this;
        var self = this;
        // Avoid over calculations from Angular by checking for changes on scroll
        this.zone.runOutsideAngular(function () {
            window.addEventListener('scroll', _this.updateScroll.bind(self));
        });
        this.scrollSubject.pipe(debounceTime(75)).subscribe(function () { return (_this.onScroll.bind(self))(); });
    };
    BackToTopComponent.prototype.updateScroll = function (e) {
        this.scrollSubject.next(e);
    };
    BackToTopComponent.prototype.onScroll = function () {
        var top = window.scrollY === undefined ? window.pageYOffset : window.scrollY;
        if (top < this.lastScrollTop) {
            this.didScrollUp = true;
        }
        else {
            this.didScrollUp = false;
        }
        if (top > this.showAtPossition) {
            this.isScrolled = true;
        }
        else {
            this.isScrolled = false;
        }
        this.lastScrollTop = top;
        if (this.isScrolled) {
            this.$backTop.nativeElement.className += this.$backTop.nativeElement.className.includes('is-scrolled') ? '' : ' is-scrolled ';
        }
        else {
            this.$backTop.nativeElement.className = this.$backTop.nativeElement.className.replace('is-scrolled', '');
        }
        if (this.didScrollUp) {
            this.$backTop.nativeElement.className += this.$backTop.nativeElement.className.includes('show-label') ? '' : ' show-label ';
        }
        else {
            this.$backTop.nativeElement.className = this.$backTop.nativeElement.className.replace('show-label', '');
        }
        this.$backTop.nativeElement.className = this.$backTop.nativeElement.className.trim();
    };
    /**
     * Scroll to top page
     */
    BackToTopComponent.prototype.scrollToTop = function () {
        var _this = this;
        // window.scroll(0, 0);
        var elementBody = document.getElementsByTagName('body')[0];
        clearTimeout(this.scrollingTimeout);
        this.isScrolling = true;
        this.scrollingTimeout = setTimeout(function () {
            _this.isScrolling = false;
        }, 600);
        elementBody.scrollIntoView({ block: 'start', behavior: 'smooth' });
    };
    BackToTopComponent.prototype.getStyles = function () {
        return {
            'is-scrolled': this.isScrolled,
            'show-label': this.didScrollUp
        };
    };
    BackToTopComponent.prototype.ngOnDestroy = function () {
        this.isAlive = false;
    };
    return BackToTopComponent;
}());
export { BackToTopComponent };
